export default "__VITE_ASSET__338b834d__"